export const PrintPrompts = {
	created: {
		header: "Label Feed?",
		message:
			"Do you want to print a label for a new container? Your original container will still be usable regardless of this choice.",
	},
} as const;
